module.exports = {
      id: "home-usage",
      viewBox: "0 0 15.417 13.987",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#home",
      toString: function () {
        return this.url;
      }
    }